import { Box, DragDrop, GKButton, Grid2, Typography } from "components";
import { useState } from "react";
import { Controller, useFormContext } from "react-hook-form";
import { WebsiteDetails } from "./types";

const InvestmentCharterForm = () => {
  const form = useFormContext<WebsiteDetails>();

  const [uploadError, setUploadError] = useState(null);

  return (
    <Grid2 container spacing={4} p={2}>
      <Grid2 size={12}>
        <Typography fontSize={14} fontWeight={700} color="var(neutral-900)">
          Investment Charter
        </Typography>
      </Grid2>

      <Grid2 size={8}>
        <Controller
          control={form.control}
          name="compliance.investmentCharter"
          render={({ field }) => (
            <DragDrop
              {...field}
              uploadError={uploadError}
              setUploadError={setUploadError}
              value={field.value}
              onChange={(e) => field.onChange(e)}
              supportName=".png, .jpg, .pdf"
              acceptType={".pdf,.png,.jpg"}
            />
          )}
        />
        <Box sx={{ display: "flex", alignItems: "center", gap: 0.5 }}>
          <GKButton
            variant="link"
            target="__blank"
            href="https://www.sebi.gov.in/sebiweb/home/HomeAction.do?doListing=yes&sid=1&ssid=7&smid=0"
          >
            Click here
          </GKButton>
          <Typography fontSize={13} color="var(--grey-500)">
            to download your applicable Investor Charter.
          </Typography>
        </Box>
      </Grid2>
    </Grid2>
  );
};

export default InvestmentCharterForm;
